import { render, staticRenderFns } from "./PosterGenerate.vue?vue&type=template&id=57a84dc2&scoped=true"
import script from "./PosterGenerate.vue?vue&type=script&lang=js"
export * from "./PosterGenerate.vue?vue&type=script&lang=js"
import style0 from "./PosterGenerate.vue?vue&type=style&index=0&id=57a84dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a84dc2",
  null
  
)

export default component.exports